import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';
import { BlockSchema } from './block';

/**
 * Layout Schema
 * Represents a custom HTML layout for league/season/division pages
 */

export const LayoutSchema = z.object({
  _id: objectId,
  html: z.string().default(''),
  name: z.string().default(''),
  pageLocation: z.string().default(''),
  tier: z.string().default(''),
  order: z.number().default(0),
  active: z.boolean().default(false),
  isConverted: z.boolean().default(false),
  // Block-based body (ADR 0033). Optional with NO default — see post.ts for
  // the absent-means-unmigrated contract; the model pins `default: undefined`.
  blocks: z.array(BlockSchema).optional(),
  // Refs
  organization: objectId,
  league: objectId,
  division: objectId,
  ...timestampFields,
});

export type Layout = z.infer<typeof LayoutSchema>;

// Metadata for Layout fields (for Mongoose refs and UI)
export const layoutMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  html: { label: 'HTML Content', editable: true },
  name: { label: 'Name', editable: true },
  pageLocation: { label: 'Page Location', editable: true },
  tier: { label: 'Tier', editable: true },
  order: { label: 'Order', editable: true },
  active: { label: 'Active', editable: true },
  isConverted: { label: 'Is Converted', editable: true },
  blocks: { label: 'Blocks', editable: true },
  organization: { ref: 'Organization', hidden: true },
  league: { ref: 'League', label: 'League' },
  division: { ref: 'Division', label: 'Division' },
  created: { hidden: true },
  updated: { hidden: true },
};
